// extracted by mini-css-extract-plugin
module.exports =  {"block":"ccfda6eb9f--block--pYUeI"};